<template>
  <router-view />
</template>

<script lang="ts">

</script>

<style>
:root {
  --stand-width: 1200px;
  --yellow-color: #ff861b;
}

/* 全局box-sizing设置，确保所有元素都继承 */
*,
*::before,
*::after {
  box-sizing: inherit;
}

html {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background-color: #f6f9ff;
}
</style>
